import Empty from 'antd/es/empty';
import Form from 'antd/es/form';
import React, {forwardRef, useImperativeHandle} from 'react';

import {
    IAddItemButtonRef,
    IOrgStructureTabProps,
} from 'pages/ais/organization-structure/organization-structure-page.types';
import {ParticipantsFields} from 'pages/ais/organization-structure/tabs/participants-tab/participants-fields/participants-fields';
import {IAntdFormListProps} from 'shared/types/antd';

interface IParticipantsListProps extends Required<IAntdFormListProps>, Pick<IOrgStructureTabProps, 'isDisabled'> {}

export const ParticipantsList = forwardRef<IAddItemButtonRef, IParticipantsListProps>((
    {
        fields,
        operations,
        errors,
        isDisabled,
    }: IParticipantsListProps,
    ref,
) => {
    const {add, remove} = operations;

    useImperativeHandle(ref, () => ({
        add,
    }), [add]);

    return (
        <>
            <Form.ErrorList errors={errors} />
            {fields?.length === 0 ? (
                <Empty description="Список пуст" />
            ) : (
                <div className="os-form-list">
                    {fields?.map(field => (
                        <ParticipantsFields
                            key={field.fieldKey}
                            field={field}
                            onRemove={remove}
                            isDisabled={isDisabled}
                        />
                    ))}
                </div>
            )}
        </>
    );
});
